"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthError = void 0;
const isAuthError = (code) => {
    if (!code)
        return false;
    // Only 401 UNAUTHORIZED requires logout (invalid/expired session)
    // 403 FORBIDDEN means user lacks permission - show error, don't logout
    return code === 401;
};
exports.isAuthError = isAuthError;
